import { HttpErrorResponse } from '@angular/common/http';
import {
  AfterViewInit,
  Component,
  Inject,
  OnInit,
  ViewChild
} from '@angular/core';
import {
  AbstractControl,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig,
  MatDialogRef
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { LinhaProducaoService } from '@app/modules/linha_producao/services/linha_producao.service';
import { IModelo } from '@app/modules/modelos/model/modelo.model';
import { ModeloService } from '@app/modules/modelos/services/modelo.service';
import {
  ConfirmDialogComponent,
  ConfirmDialogData
} from '@app/shared/components';
import { Utils } from '@app/shared/helpers/utils';
import { ScreenService } from '@app/shared/services';
import { Dialog } from 'primeng/dialog';

import {
  CustomValidators,
  ErroMessages,
  IErroMessages,
  TokenService
} from 'viggo-sistemas-core-web';

@Component({
  templateUrl: './fast-modelo.component.html',
  styleUrls: ['./fast-modelo.component.scss'],
  providers: [ModeloService, LinhaProducaoService]
})
export class FastModelosComponent implements OnInit, AfterViewInit {
  @ViewChild('fastModelo') fastModelo: Dialog;
  public form: UntypedFormGroup;

  loading = false;

  displayMessage = {
    descricao: {
      duplicate: 'Já existe um modelo com essa descrição!',
      required: 'Descrição é obrigatória',
      maxlength: 'Não pode ter mais de 60 caracteres',
      isEmptyValue: 'Valor inválido: remova os campos em branco!'
    }
  };

  constructor(
    public screenService: ScreenService,
    public dialogRef: MatDialogRef<FastModelosComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IModelo,
    protected fb: UntypedFormBuilder,
    public entityService: ModeloService,
    public linhaProducaoService: LinhaProducaoService,
    public tokenService: TokenService,
    public matSnackBar: MatSnackBar,
    public matDialog: MatDialog,
    public router: Router
  ) {}

  ngAfterViewInit(): void {
    if (this.screenService.detectDeviceInfo().isMobile)
      this.fastModelo.maximize();
  }

  ngOnInit() {
    this.form = this.fb.group({
      descricao: [
        '',
        [
          Validators.required,
          Validators.maxLength(60),
          CustomValidators.isEmptyValue()
        ]
      ],
      linha_producao: [
        null,
        [
          Validators.required,
          CustomValidators.typeIs('object'),
          CustomValidators.isEmptyValue()
        ]
      ]
    });
    this.validateForm();
  }

  onSubmit() {
    if (this.form.valid) {
      this.loading = true;
      const { ...rest } = this.form.value;
      var entity = Utils.trimAttributes({
        domain_id: this.tokenService.getDomain().id,
        ...rest
      });
      entity.linha_producao_id = entity.linha_producao.id;
      delete entity.linha_producao;
      this.entityService.insert(entity).subscribe(
        modelo => {
          if (modelo) {
            this.matSnackBar.open(`Novo modelo cadastrado com sucesso.`, 'X', {
              duration: 2000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: ['msg-success']
            });
            this.dialogRef.close(modelo);
          }
        },
        (err: HttpErrorResponse) => {
          this.displayError(err);
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    }
  }

  markAllControlsAsDirty() {
    Object.keys(this.form.controls).forEach(controlKey => {
      controlKey = String(controlKey);
      const control = this.form.get(controlKey);
      if (!control || control.valid) return;
      control.markAsDirty();
    });
  }

  validateForm() {
    this.form.markAllAsTouched();
    this.markAllControlsAsDirty();
  }

  actionFnCheckEntityExist(control: AbstractControl) {
    Utils.checkIfValueExist(
      control,
      this.entityService,
      'descricao',
      this.tokenService.getDomain().id
    );
  }

  displayError(err: HttpErrorResponse, showDefaultMsg = false) {
    const errorMsg = new ErroMessages({
      route: this.router.url,
      router: this.router,
      matSnackBar: this.matSnackBar,
      httpError: err,
      showDefaultMsg: showDefaultMsg,
      loginService: null,
      tokenService: this.tokenService,
      dialogComponent: ConfirmDialogComponent,
      matDialog: this.matDialog,
      dialogData: {
        config: {
          data: {
            title: 'Aviso - Erro ao realizar operação',
            bodyMessage: err.error,
            icon: 'warning',
            icon_color: 'accent',
            singleBtn: true
          } as ConfirmDialogData,
          disableClose: true,
          width: '500px'
        } as MatDialogConfig<any>
      }
    } as IErroMessages);
    errorMsg.showMessageObject(err.error);
    // errorMsg.checkError();
  }
}
